














































































import { Dialog, Button, Collapse, CollapseItem } from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component } from 'vue-property-decorator'
import { Location, Route } from 'vue-router'

import BookingTopNav from '@/components/BookingTopNav.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import SuccessPaymentTab from '@/components/modals/SuccessPaymentTab.vue'
import PaymentHeader from '@/components/PaymentHeader.vue'

import Booking from '@/models/booking'
import Passenger from '@/models/passenger'
import Payment from '@/models/payment'

import BookingHeaderTitleMixin from '@/mixins/BookingHeaderTitleMixin.vue'
import store from '@/store'
import { BookingsActionTypes } from '@/store/modules/bookings'
import { PaymentActionTypes } from '@/store/modules/payments'

@Component({
  components: {
    PaymentHeader,
    BookingTopNav,
    LoadingPlaceholder,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    SuccessTab: SuccessPaymentTab,
  },
})
export default class Payments extends mixins(BookingHeaderTitleMixin) {
  printedPayment: Payment | null = null

  beforeRouteEnter(to: Route, from: Route, next: (to?: Location) => void) {
    store.dispatch(BookingsActionTypes.Get, to.params.id)
    store.dispatch(PaymentActionTypes.LoadByBookingId, to.params.id)
    next()
  }

  get loaderOptions() {
    if (window.innerWidth > 992) {
      return {
        preserveAspectRatio: 'none',
        height: 60,
        width: 300,
      }
    } else if (window.innerWidth > 768) {
      return {
        preserveAspectRatio: 'none',
        height: 60,
        width: 225,
      }
    } else {
      return {
        preserveAspectRatio: 'none',
        height: 60,
        width: 300,
      }
    }
  }

  get paymentsPlaceholder() {
    if (window.innerWidth > 768) {
      return 'ContentLoaderPayment'
    } else {
      return 'ContentLoaderPaymentMobile'
    }
  }

  get passengerEntities() {
    return this.$store.state.passengers.passengerEntities
  }

  get booking(): Booking {
    return this.$store.getters.getBooking(this.$route.params.id)
  }

  get payments(): Payment[] {
    if (!this.booking) {
      return []
    }
    return this.$store.getters.getPaymentsByIds(this.booking.paymentIds)
  }

  get paymentsLoaded(): boolean {
    return this.$store.state.payments.isLoaded
  }

  get passengers(): Passenger[] {
    const passengers: Passenger[] = this.$store.getters.getPassengersByIds(
      this.booking.passengerIds,
    )

    return passengers.sort((a) => (a.customerId ? -1 : 1))
  }
}
